<template>
  <div ref="member" class="member" :class="{'member--highlighted': isHighlighted}">
    <v-checkbox v-model="isMemberSelected"
                :label="member.fullName"
                :disabled="isMemberDisabled"
                hide-details
                density="compact"
                data-locator="member-selection"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import { DocumentSharePickerActionTypes } from '@/store/modules/document-share-picker/action_types'
import { DocumentSharePickerMutationTypes } from '@/store/modules/document-share-picker/mutation_types'

export default {
  name: 'DocumentSharePickerMember',
  props: {
    member: {
      type: Object,
      required: true,
    },
    groupIsForced: {
      type: Boolean,
    },
    groupIsSelected: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    usersOnly: {
      type: Boolean,
    },
    multiSelect: {
      type: Boolean,
    },
  },
  data () {
    return {
      isHighlighted: false,
    }
  },
  computed: {
    ...mapState('documentSharePicker', ['selectedMembers', 'disabledMembers', 'highlightedMember']),
    isMemberSelected: {
      get () {
        return this.selectedMembers.some(member => member.id === this.member.id) ||
          this.groupIsSelected ||
          this.disabledMembers.some(member => member.id === this.member.id)
      },
      set (memberIsSelected) {
        if (memberIsSelected) {
          if (this.multiSelect) {
            this.ADD_MEMBERS_TO_SELECTED([this.member])
          } else {
            this.SET_SELECTED_MEMBERS([this.member])
          }
        } else {
          this.groupIsSelected
            ? this.$emit('removeMemberFromSelectedGroup', this.member.id)
            : this.UNSELECT_MEMBER(this.member)
        }
      },
    },
    isMemberDisabled () {
      return this.disabledMembers.some(member => member.id === this.member.id) || this.disabled || this.groupIsForced
    },
  },
  watch: {
    highlightedMember (value) {
      if (value?.id === this.member.id) {
        this.isHighlighted = true
        this.$refs.member.scrollIntoView({ behavior: 'smooth', block: 'center' })
      } else {
        this.isHighlighted = false
      }
    },
  },
  methods: {
    ...mapActions('documentSharePicker', [
      DocumentSharePickerActionTypes.UNSELECT_MEMBER,
    ]),
    ...mapMutations('documentSharePicker', [
      DocumentSharePickerMutationTypes.ADD_MEMBERS_TO_SELECTED,
      DocumentSharePickerMutationTypes.SET_SELECTED_MEMBERS,
    ]),
  },
}
</script>

<style scoped lang="scss">
.member {
  transition: background-color .4s ease-in-out;

  &--highlighted {
    background-color: rgb(var(--v-theme-info-lighten-5));
  }
}
</style>
